/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DerivativesMarginMode {
    ISOLATED = 'Isolated',
    CROSS = 'Cross',
    CASH = 'Cash',
}
